<div class="midi-chords" [ngStyle]="{'color':color?color:'#000'}"> {{chord_name}} </div>